import { useQuery } from '@tanstack/react-query'
import { sportTypesApi } from '@/api/sportTypes'

// Получить список видов спорта (справочник)
export function useSportTypes() {
  return useQuery({
    queryKey: ['sport-types'],
    queryFn: () => sportTypesApi.list(),
    staleTime: 30 * 60 * 1000, // 30 минут — справочник меняется редко
  })
}
